module.exports = __webpack_public_path__ + "static/media/quebra.fa0bbf18.svg";